import React from 'react';
import { SkeletonLoader } from '@hpstellar/core';
import { Typography } from '@hpstellar/core/visId';
import MSRPTooltip from './msrp-tooltip';

import './starting-at-price.less';

export default ({ price, pricePrefix, strikePrice, tierMsg, isLoading, productType, msrpTooltipProps }) => {
    if (isLoading) {
        return <SkeletonLoader className="starting-at-price price-block-loader" />;
    }

    return (
        <div className={`starting-at-price`}>
            {tierMsg && (
                <Typography variant="body1" className="tier-msg" tag="p">
                    {tierMsg}
                </Typography>
            )}
            <MSRPTooltip productType={productType} tooltipProps={msrpTooltipProps}>
                {pricePrefix && (
                    <Typography variant="body1" tag="span" className="price-prefix">
                        {pricePrefix}&nbsp;
                    </Typography>
                )}
            </MSRPTooltip>
            {price && (
                <Typography variant="body1" tag="span" className={`price${strikePrice ? ' strike-price' : ''}`}>
                    {price}
                </Typography>
            )}
        </div>
    );
};
